import React, { useContext, useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Fab from "@mui/material/Fab";
import instance from "../api/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {
  Button,
  CardActionArea,
  CardActions,
  Grid,
  TextField,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";

// import { makeStyles } from "@mui/styles";
// import { createMuiTheme } from '@mui/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import AspectRatio from "@mui/joy/AspectRatio";
import { Context } from "../context/ContextProvider";
import Paper from "@mui/material/Paper";
import CartItem from "../components/Cart/CartItem/CartItem";
import CartItemM from "../components/Cart/CartItemM";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { Stepper, Step, StepLabel } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
      // direction: "rtl",
    },
  },
  paper: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  table: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  avatar: {
    marginBottom: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  icons: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    top: 5,
    right: 5,
  },
}));

export default function Payment({ t }) {
  let navigate = useNavigate();

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
  } = useContext(Context);
  const [activeStep, setActiveStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const [values, setValues] = React.useState({
    country: "",
    email: "",
    displayName: "",
    phone: "",
    city: "",
    address: "",
    neighborhood: "",
  });
  const kindSex = ["البحرين", "قطر", "الكويت", "الإمارات", "السعودية"];
  const kindSocialState = [
    "متزوج/متزوجة",
    "أعزب/عزباء",
    "أرمل/أرملة",
    "مطلق/مطلقه",
  ];
  const kindWorkingCase = ["موظف/موظفة", "غير موظف/غير موظفة"];

  const handleChange = (prop) => (event) => {
    // console.log("token: ", token);
    setValues({ ...values, [prop]: event.target.value });
  };

  const addNewDream = async (e) => {
    // setLoading(true);
    e.preventDefault();

    // if (password === "") {
    //   setLoading(false);

    //   alert("Password cannot be empty");
    //   return;
    // }

    // if (password.length < 7) {
    //   setLoading(false);
    //   alert("Password is very small");
    //   return;
    // }

    // setPassword(password);
    // console.log("values: ",values);
    let result;

    result =
      setValues({
        country:"",
        email:"",
        displayName:"",
        phone:"",
        city:"",
        address:"",
        neighborhood:"",
      }) & alert("تم إضافة المعومات بنجاح");

    // try {
    //   instance
    //     .post(`/questions/create-question-by-email`, values)
    //     .then(({ data }) => {
    //       // console.log("data: ",  data , );

    //       if (typeof data == "string" && data.startsWith("you") === true) {
    //         result = alert("يوجد خطأ  في البريد أو الرقم السري");
    //       } else {
    //         // console.log("data: ",  data.itemNo);

    //         // sendPushNotificationToAdmin(data.itemNo);
    //         result =
    //           setValues({
    //             email: "",
    //             ps: "",
    //             title: "",
    //             selectSex: "",
    //             socialState: "",
    //             workingCase: "",
    //             age: "",
    //             active: true,
    //             chooseType: "chat1999",
    //           }) & alert("تم إضافة الحلم بنجاح");

    //         // history.replace(location);
    //       }
    //       return result;
    //     });
    //   setPassword("");

    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 1000);
    // } catch (error) {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 1000);
    //   console.clear();
    //   console.error("Sorry .. you can't access this page");
    // }
  };

  return (
    <Container
      sx={{
        // p: 2,
        // margin: "auto",
        // m: 2,
        // // maxWidth: 500,
        // flexGrow: 1,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "#1A2027" : "#F6F6F6",
      }}
    >
      <Box width="80%" m="100px auto 50px auto" height={"50px"} p="20px ">
        <Stepper
          style={{ backgroundColor: "#F6F6F6" }}
          activeStep={activeStep}
          sx={{ m: "20px 0" }}
        >
          <Step>
            <StepLabel> </StepLabel>
          </Step>
          <Step>
            <StepLabel> </StepLabel>
          </Step>
          <Step>
            <StepLabel> </StepLabel>
          </Step>
        </Stepper>
      </Box>

      {cartItmes.length > 0 ? (
        <Box
          sx={{
            // p: 2,
            margin: "auto",
            m: 2,
            // maxWidth: 500,
            flexGrow: 1,
            // backgroundColor: (theme) =>
            //   theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          }}
        >
          <Grid container justifyContent="center" >
            <Grid item xs={12} >
              <Typography variant="h5"> طريقة الدفع</Typography>
            </Grid>

            <Grid item xs={12} >
              <Button
                size="large"
                endIcon={<KeyboardBackspaceIcon />}
                backgroundColor={"red"}
                fullWidth
                sx={{ width: "100%", padding: 1 }}
                variant="contained"
                onClick={() => {
                  console.log("data item: ");
                  setActiveStep(2);
                  // navigate(`/home`);
                }}
              >
                استمرار
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : null}

      {cartItmes.length === 0 ? (
        <Box
          display="flex"
          alignItems="center"
          border={`1.5px solid #e2e1e1`}
          m="20px"
          p="2px 5px"
        >
          This is Cart is Empty ...
          <Button onClick={() => navigate(`/home`)}>back</Button>
        </Box>
      ) : null}

      <Box width="80%" m="100px auto 50px auto" height={"50px"} p="20px "></Box>
    </Container>
  );
}

// https://mulfet.com/checkout/mxqxGkdMO6NnXKo301VE7JzYQbX1xojWpLmWyAe9Zg2b48Dwr5BalRjZ
